import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // CAMBIO CLAVE: Cambiar localStorage por sessionStorage
  const auth = sessionStorage.getItem('isAuthenticated');
  const location = useLocation(); 

  if (auth !== 'true') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;